import request from '@/services/request'
import { getApiUrl } from '@/utils/tool'

export function loadLanguageAsync(object) {
  return request({
    cache: {
      key: req => {
        return req.url + JSON.stringify(object)
      },
      maxAge: 5 * 60 * 1000,
      exclude: {
        methods: ['put', 'patch', 'delete']
      }
    },
    baseURL: getApiUrl(),
    url: '/common/get-language-messages',
    method: 'post',
    data: object
  })
}

export function page(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/common/get-page',
    method: 'post',
    data: object
  })
}

export function getCommonTransactionStatus(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/common/get-common-transaction-type',
    method: 'post',
    data: object
  })
}

export function getCommissionTransactionStatus(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/common/get-commission-transaction-type',
    method: 'post',
    data: object
  })
}

export function getBonusTransactionStatus(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/common/get-bonus-transaction-type',
    method: 'post',
    data: object
  })
}
